import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { theme } from 'antd';
import CustomSelect from 'components/CustomSelect';
import CustomDatePicker from 'components/CustomDatePicker';
import { IAudits } from 'store/ducks/Gaps/types';
import * as Styled from './AuditsSelectBox.styled';

const { useToken } = theme;

export interface IAuditsSelectBoxProps {
  audits: IAudits[];
  valueKey: string;
  dateEl?: boolean;
}

export const AuditsSelectBox: React.FC<IAuditsSelectBoxProps> = ({
  audits,
  valueKey,
  dateEl = false
}) => {
  const { token } = useToken();

  // Remove duplicates based on the valueKey
  const uniqueAudits = audits.filter(
    (audit, index, self) =>
      index ===
      self.findIndex(
        (a) =>
          a[valueKey as keyof typeof a] ===
          audit[valueKey as keyof typeof audit]
      )
  );

  return (
    <Styled.Container>
      {uniqueAudits.map((audit: IAudits) => (
        <Styled.InfoContainer key={uuidv4()}>
          <Styled.IdContainer token={token}></Styled.IdContainer>
          {dateEl ? (
            <CustomDatePicker defaultValue={audit.afg_due_date} disabled />
          ) : (
            <CustomSelect
              size='md'
              options={[]}
              defaultValue={audit[valueKey as keyof typeof audit]}
              disabled
            />
          )}
        </Styled.InfoContainer>
      ))}
    </Styled.Container>
  );
};
